export default "__VITE_ASSET__XOI8ydFB__"